<form class="field" [formGroup]="form" [ngClass]="{'active':isActive}">
    <button class="field-action">
        <div class="field-action-media">
            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
        </div>
    </button>
    <input autocomplete="off" class="field-input" (focus)="setActive()"
           formControlName="query" id="input" placeholder="Global menu search" type="text">
    @if (isSearching()) {
        <div class="modal" [@fade]>
            @if (!results.length) {
                <div class="modal-message">
                    <fui-empty [description]="'fui.$navigation.message.noResultsDescription'"
                               id="empty" [title]="'fui.$navigation.message.noResultsTitle'">
                        <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
                    </fui-empty>
                </div>
            }
            @if (results.length) {
                <div class="modal-main">
                    <div class="results">
                        @for (result of results; track result; let index = $index) {
                            <button class="result" id="result-{{index}}"
                                    [routerLink]="result.href"
                                    [ngClass]="{'disabled':result.availability === null || (result.availability | async) === FUINavigationLinkAvailability.DISABLED}">
                                <div class="result-breadcrumbs">
                                    @for (breadcrumb of result.breadcrumbs; track breadcrumb; let depth = $index) {
                                        <div class="result-breadcrumbs-breadcrumb" id="breadcrumb-{{depth}}"
                                        >
                                            {{ breadcrumb | translate }}
                                        </div>
                                    }
                                </div>
                                <div class="result-label">
                                    <div class="result-label-title" id="title">
                                        {{ result.title | translate }}
                                    </div>
                                </div>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
    }
</form>
